import { FC } from "react";

import { clsxMerge } from "shared/lib/helpers";
import { MetricItem } from "@/components/base/metrics/metric-item";
import { MetricItemI } from "@/components/base/metrics/interfaces";

interface MetricsPropsI {
  className?: string;
  metrics?: MetricItemI[];
}

export const Metrics: FC<MetricsPropsI> = ({ className, metrics }) => (
  <div
    className={clsxMerge(
      "flex flex-col items-start justify-center gap-9",
      "lg:flex-row",
      "lg:gap-[92px]",
      className
    )}
  >
    {metrics?.map((metric, i) => (
      <MetricItem key={i} {...metric} />
    ))}
  </div>
);
